import { compose, createStore, applyMiddleware } from "redux";
import createRootReducer from "./reducers";

// allows you to write action creators that return a function instead of an action
import thunk from "redux-thunk";
import { routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";

// const preloadedState = {};
const enhancers = [];

// https://github.com/zalmoxisus/redux-devtools-extension
const devToolsExtension = (window as any)["__REDUX_DEVTOOLS_EXTENSION__"];
if (typeof devToolsExtension === "function") {
  enhancers.push(
    devToolsExtension({
      trace: false, // if set to true, will include stack trace for every dispatched action
      traceLimit: 10,
      // Whitelist supersedes blacklist
      //   actionsBlacklist: [], // string or array of strings as regex - actions types to be hidden in the monitors
      //   actionsWhitelist: [], // string or array of strings as regex - actions types to be shown in the monitors
    })
  );
}

export const history = createBrowserHistory({ basename: `/` });
const middleware = [
  thunk, // async action support
  routerMiddleware(history), // dispatch history action support
];

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

export default function configureStore(preloadedState?: object) {
  return createStore(
    createRootReducer(history), // root reducer with router state
    preloadedState,
    composedEnhancers
  );
}
